import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'
import { PageHeader } from 'mailup-web-components'
import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['EmailMessageNew', redirectUrl])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Saved' }),
      'data-mu-test': 'breadcrumb-item__saved',
      className: 'test-breadcrumb-item__saved',
      url: '#',
      onClick: () => history.push('/messages/email/saved')
    },
    {
      label: intl.formatMessage({ id: 'Load.Common.Create' }),
      'data-mu-test': 'breadcrumb-item__create'
    }
  ]

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      title={intl.formatMessage({ id: 'Load.Common.Create' })}
    />
  )
}

export default Header
